import { CheckCircle2, AlertTriangle, XCircle, HelpCircle } from 'lucide-react';

/**
 * Presentation for the vehicle-fit verdict computed by the API
 * (server/src/services/fit.service.js). The classification itself is NOT
 * duplicated here — only its styling. One source of truth for the rules.
 */
export const FIT_STYLES = {
  perfect: {
    label: 'Fits',
    Icon: CheckCircle2,
    pill: 'bg-emerald-100 text-emerald-800 ring-1 ring-emerald-600/20',
    banner: 'bg-emerald-50 border-emerald-200 text-emerald-900',
    dot: 'bg-emerald-500',
    pin: 'bg-emerald-600 text-white ring-emerald-700',
  },
  tight: {
    label: 'Tight fit',
    Icon: AlertTriangle,
    pill: 'bg-amber-100 text-amber-900 ring-1 ring-amber-600/20',
    banner: 'bg-amber-50 border-amber-200 text-amber-900',
    dot: 'bg-amber-500',
    pin: 'bg-amber-500 text-white ring-amber-600',
  },
  incompatible: {
    label: "Won't fit",
    Icon: XCircle,
    pill: 'bg-rose-100 text-rose-800 ring-1 ring-rose-600/20',
    banner: 'bg-rose-50 border-rose-200 text-rose-900',
    dot: 'bg-rose-500',
    pin: 'bg-white text-slate-400 ring-slate-300',
  },
  unknown: {
    label: 'Add your vehicle',
    Icon: HelpCircle,
    pill: 'bg-slate-100 text-slate-700 ring-1 ring-slate-500/20',
    banner: 'bg-slate-50 border-slate-200 text-slate-800',
    dot: 'bg-slate-400',
    pin: 'bg-white text-slate-900 ring-slate-300',
  },
};

export const fitStyle = (status) => FIT_STYLES[status] ?? FIT_STYLES.unknown;

/** Presets seed sensible dimensions; tenants adjust from there. */
export const VEHICLE_KINDS = [
  { value: 'camper_van',     label: 'Camper van',     length: 20, width: 7.5, height: 9.5 },
  { value: 'truck_camper',   label: 'Truck camper',   length: 22, width: 8,   height: 11 },
  { value: 'car',            label: 'Car',            length: 16, width: 6.5, height: 5 },
  { value: 'boat',           label: 'Boat on trailer', length: 28, width: 9,  height: 10 },
  { value: 'travel_trailer', label: 'Travel trailer', length: 30, width: 8.5, height: 11 },
  { value: 'motorhome',      label: 'Motorhome',      length: 38, width: 8.5, height: 12.5 },
  { value: 'fifth_wheel',    label: 'Fifth wheel',    length: 38, width: 8.5, height: 13 },
  { value: 'trailer',        label: 'Utility trailer', length: 20, width: 8,  height: 8 },
];

export const vehicleKindMeta = (value) =>
  VEHICLE_KINDS.find((k) => k.value === value) ?? VEHICLE_KINDS[4];

export const SPACE_TYPE_LABELS = {
  open: 'Uncovered', covered: 'Covered', enclosed: 'Enclosed',
};
